import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.COMPLAINT_CREATE_SUCCESS, complaint: data.complaint });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.COMPLAINT_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const complaintCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.COMPLAINT_CREATE_REQUEST });

    axios.post('/tickets', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
